// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js"}[chunkId] + "-" + {"532":"aaf1d44c4e18da5df1e8","678":"893f7a0655de1971b7d7"}[chunkId] + ".js";
};